import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { UploadedFile } from '@/types/uploadedFiles';

interface UploadedFilesState {
  files: UploadedFile[];
  isLoading: boolean;
  error: string | null;
}

const initialState: UploadedFilesState = {
  files: [],
  isLoading: false,
  error: null,
};

const uploadedFilesSlice = createSlice({
  name: 'uploadedFiles',
  initialState,
  reducers: {
    fetchUploadedFilesRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchUploadedFilesSuccess: (state, action: PayloadAction<UploadedFile[]>) => {
      state.files = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    fetchUploadedFilesFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchUploadedFilesRequest,
  fetchUploadedFilesSuccess,
  fetchUploadedFilesFailure,
} = uploadedFilesSlice.actions;

export default uploadedFilesSlice.reducer;